import Image from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./TestimonialCard.module.scss";

interface TestimonialCardProps {
  profilePicture: string;
  heading: string;
  review: string;
  customer: {
    name: string;
    country?: string;
    duration: string;
  };
  className?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  profilePicture,
  heading,
  review,
  customer,
  className=""
}) => {
  const cls = classNameGenerator(styles);

  return (
    <div className={clsx(cls("testimonialCard"),cls(className))}>
      <div
        className={cls("testimony")}
        style={!profilePicture ? { marginTop: "30px" } : {}}
      >
        {heading && (
          <Typography variant="heading3" className={cls("heading")}>
            {heading}
          </Typography>
        )}
        <Typography
          variant="paragraph1"
          className={cls("review")}
          dangerouslySetInnerHTML={{ __html: review }}
        />
      </div>
      <div className={cls("customerInfo")}>
        {profilePicture && (
          <div className={cls("profilePicture")}>
            <Image src={profilePicture} alt="profilePicture" />
          </div>
        )}
        <div className={cls("info")}>
          <Typography variant="heading3" className={cls("name")}>
            {customer.name}
          </Typography>
          {customer.country && (
            <Typography variant="heading4" className={cls("country")}>
              {customer.country}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
